
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const PasswordChange = (prop) => {
  
  const InitState ={
    username:null,
    oldpassword:null,
    newpassword:null,
    user:prop.username
  }
  const [formData, setFormData] = useState(InitState);

  const[username,setUsername]=useState('')
  const[rights,setRights]=useState('')

  useEffect(()=>{
    setUsername(sessionStorage.getItem('username'))
    setRights(sessionStorage.getItem('rights'))
  })

  const handleChange = (e) => {
    const { name, value } = e.target;
    if(name === "username"){
      setFormData({
        ...formData,
        [name]: value.replace(/[^a-zA-Z\s]/g, '').trim().toUpperCase()
      }); 
    }else{
    setFormData({
      ...formData,
      [name]: value
    });
  }
}
const SuccessMSG = (msg) =>{
  //console.log(msg)
  toast.success(msg, {
      position:"top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: true, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
}

const WarningMSG = (msg) =>{
//console.log(msg)
toast.warning(msg, {
    position:"top-center",
    autoClose: 2000, // Auto-dismiss after 2 seconds
    hideProgressBar: true, // Optional: Hide progress bar
    closeOnClick: true, // Optional: Allow closing on click
    pauseOnHover: false, // Optional: Pause on hover
    draggable: false, // Optional: Disable dragging
  });
}

const FailedMSG = (msg) =>{
  //console.log(msg)
  toast.error(msg, {
      position: "top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: true, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
} 
const handleSubmit = (event) => {
  event.preventDefault();
  try{
     axios.post(`${process.env.REACT_APP_API_BASE_URL}/user/UserPasswordChange`,formData,{headers: {
      Authorization: `Bearer ${sessionStorage.getItem('access_token')}` 
    }
      }).then((res)=>{
      if(res.status === 200){SuccessMSG(res.data.message);}
      if(res.status === 201){ WarningMSG(res.data.message);}
      formData([]);}).catch((error)=> {
        if(error.response && error.response.status !==200)
          FailedMSG('Something went Wrong');});
    event.target.reset();
  }catch(error){
    if(error.response && error.response.status !==200)
      FailedMSG('Something went Wrong');
  }
  setFormData(InitState);
};

  return (
    <div className="FormContainer">
    <ToastContainer />
      <h2 className='UserManagementFormHeadLabel'>Password Change</h2>
      <form className='UserManagementForm' onSubmit={handleSubmit}>
        <label className='UserManagementPageFormLables' >Username </label><input  placeholder='Username' onChange={handleChange} value={formData.username} required className='UserManagementPageFormInputs' type="text" id="username" name="username" />
        <br />
        <label className='UserManagementPageFormLables' >Enter Old Password </label><input  placeholder='Old Password' onChange={handleChange} value={formData.oldpassword} required className='UserManagementPageFormInputs' type="password" id="password" name="oldpassword" />
        <br />
        <label className='UserManagementPageFormLables' >Enter New Password </label><input  placeholder='New Password' onChange={handleChange} value={formData.newpassword} required className='UserManagementPageFormInputs' type="password" id="password" name="newpassword" />
        <br />
        <button  className='UserManagementPageFormSumbit'  title='Submit' type="submit">Submit</button>
      </form>
    </div>
  );
};

export default PasswordChange;
